import { render, staticRenderFns } from "./jurusan.vue?vue&type=template&id=0a518f1a&"
import script from "./jurusan.vue?vue&type=script&lang=js&"
export * from "./jurusan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports